module.exports = __webpack_public_path__ + "static/media/starterguidestep2.d237926d.png";